<template>
  <div>
    <h1>{{ $t('addYourOffices') }}</h1>
    <div class="labels-wrapper">
      <div class="label">{{ $t('name') }}</div>
      <div class="label">{{ $t('timeZone') }}</div>
    </div>

    <div v-for="(el, index) in officesArray" :key="'office' + el.id" class="office-line">
      <color-picker :ref="'colorPicker'" v-model="el.color" :color-prop="el.color" only-circle class="color-dot" />
      <div class="fields-wrapper">
        <editable-input :ref="'editableInput'" v-model="el.name" autofocus auto-capitalize="on" class="office-name" />
        <dropdown :ref="'dropdown'" v-model="el.timezone" show-all editable auto-complete :options="timezones" class="office-timezone" />
      </div>
      <div class="delete-wrapper">
        <div v-if="officesArray.length !== 1" class="button-icon" @click="deleteLine(index)">
          <img src="@/assets/ico/close-L-gray.svg" alt="delete" :title="$t('removeItem')" />
        </div>
      </div>
    </div>

    <div @click="addNextLine" class="button-add">
      <div class="add-circle">
        <svg height="11" width="11" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.5 0c.276 0 .5.22.5.493V5h4.5a.5.5 0 01.492.41L11 5.5a.5.5 0 01-.5.5H5.999L6 10.507a.495.495 0 01-.41.485L5.5 11c-.276 0-.5-.22-.5-.493l-.001-4.508L.5 6a.5.5 0 01-.492-.41L0 5.5A.5.5 0 01.5 5L5 4.999V.493c0-.242.177-.443.41-.485z"
          />
        </svg>
      </div>
      {{ $t('addMore') }}
    </div>

    <button class="clavo-button primary big" @click="nextStage">
      {{ $t('next') }}
    </button>
  </div>
</template>

<script>
import Dropdown from '@/components/UI/Dropdown'
import EditableInput from '@/components/UI/EditableInput'
import Constants from '@/components/Constants'
import vClickOutside from 'v-click-outside'
import ColorPicker from '@/components/UI/ColorPicker'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'

export default {
  name: 'AddOffices',

  components: {
    ColorPicker,
    EditableInput,
    Dropdown,
  },

  directives: { clickOutside: vClickOutside.directive },

  mixins: [Constants, ParseFunctions],

  props: {
    addedOffices: {
      default: () => [],
      type: Array,
    },
  },

  data() {
    return {
      officesArray: [],
      userTimezone: '',
      timezones: undefined,
      colorIndex: 6,
      teamId: '',
    }
  },
  async created() {
    this.teamId = this.$route.query.teamId
    let moment = require('moment-timezone')
    this.timezones = this.$store.state.timezonesGlobal
    let guessTimezone = moment.tz.guess()
    this.userTimezone = this.timezones.find(x => x.value === guessTimezone)

    this.officesArray = this.addedOffices

    const numOfPossibleColors = this.colorsHashArray().length
    this.colorIndex = Math.floor(Math.random() * numOfPossibleColors)

    if (this.officesArray.length === 0) {
      await this.addNextLine()
    }
  },

  methods: {
    addNextLine() {
      this.officesArray.push({
        name: '',
        timezone: this.userTimezone.value,
        color: this.colorsHashArray(this.colorIndex).hash,
        id: Math.floor(Math.random() * Date.now()).toString() + 'email',
      })
      this.colorIndex++
    },

    deleteLine(index) {
      this.officesArray.splice(index, 1)
    },

    async nextStage() {
      if (this.officesArray.filter(el => el.name.length > 0).length > 0) {
        this.$emit('update-offices', this.officesArray.filter(el => el.name.length > 0))
        this.$emit('push-to-next-stage')
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('officeNamesCantBeEmpty'),
          error: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.labels-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-top: 48px;
  margin-bottom: 5px;
  margin-left: -30px;

  @include respond-below(md) {
    margin-left: 0;
  }

  .label {
    @include label;
    flex: 1;
    &:first-child {
      margin-left: 30px;
      margin-right: 48px;
      @include respond-below(md) {
        margin-right: 30px;
      }
    }
    &:last-child {
      margin-right: 42px;
      @include respond-below(xs) {
        display: none;
      }
    }
  }
}
.office-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;
  margin-left: -30px;

  @include respond-below(md) {
    margin-left: 0;
  }
  @include respond-below(xs) {
    margin-bottom: 30px;
    margin-right: -24px;
  }

  .fields-wrapper {
    flex: 1;
    display: flex;

    @include respond-below(xs) {
      flex-direction: column;
    }

    .office-name {
      flex: 1;
      margin-right: 48px;
      @include respond-below(md) {
        margin-right: 30px;
      }
      @include respond-below(xs) {
        margin-right: 0;
        margin-bottom: 12px;
      }
    }
    .office-timezone {
      flex: 1;
    }
  }
  .color-dot {
    // occupies 30px;
    @include respond-below(xs) {
      align-self: flex-start;
      margin-top: 12px;
    }
  }
  .delete-wrapper {
    width: 42px; // 36 + 6 see below
    @include respond-below(xs) {
      height: 100%;
    }
  }
  .button-icon {
    width: 36px;
    height: 36px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 6px;
    &:hover {
      background-color: $white-lilac;
    }
  }
}

.button-add {
  display: inline-flex;
  color: $blue;
  cursor: pointer;
  font-family: $semibold;
  letter-spacing: 0;
  margin-bottom: 60px;
  // margin-left: -29px;
  .add-circle {
    background: $blue;
    color: white;
    width: 23px;
    height: 23px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    transition: all ease-in-out 0.15s;
  }
  &:hover {
    // color: rgba($blue, 0.9);
    .add-circle {
      background: white;
      border: 1px solid $blue;
      svg {
        fill: $blue;
      }
    }
  }
}

button {
  display: block;
  @include respond-below(xs) {
    width: 100%;
  }
}
</style>